import React, { Fragment, useEffect, useState } from 'react';
import { fetchQrSvg, qrCacheKey } from './qrHelpers';

/**
 * Renders the QR markup returned by `/apidam/qr/{qrCodeId}/svg`.
 * The endpoint sits behind the auth header, so the svg is pulled through Axios
 * instead of being pointed at from an <img src="..." />.
 */
const QrPreview = ({ item, size = 96, className = '' }) => {
  const [markup, setMarkup] = useState('');
  const [status, setStatus] = useState('loading');
  const cacheKey = qrCacheKey(item);

  useEffect(() => {
    let isActive = true;

    if (!item?.qrCodeId) {
      setStatus('error');
      return undefined;
    }

    setStatus('loading');
    fetchQrSvg(item)
      .then((data) => {
        if (!isActive) return;
        setMarkup(data);
        setStatus(data ? 'done' : 'error');
      })
      .catch(() => {
        if (!isActive) return;
        setStatus('error');
      });

    return () => {
      isActive = false;
    };
  }, [cacheKey, item?.qrCodeId]);



  

  return (
    <Fragment>
      <div
        className={`qr_code_preview_box ${className}`}
        style={{ width: size, height: size, minWidth: size }}
      >
        {status === 'loading' && <div className="qr_code_preview_placeholder" />}
        {status === 'error' && <div className="qr_code_preview_error">QR unavailable</div>}
        {status === 'done' && (
          <div
            className="qr_code_preview_svg"
            // markup comes from the DAM API itself, same trust level as the rest of the module
            dangerouslySetInnerHTML={{ __html: markup }}
          />
        )}
      </div>
    </Fragment>
  );
};

export default QrPreview;
